/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface InputEventOffsetEUMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for input events of the asset
 *
 * ```typescript
 *  import {getInputEventOffsetEUMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getInputEventOffsetEUMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getInputEventOffsetEUMarker = ({
  fillColor = dlsColor('electricPurple'),
  borderColor = dlsColor('white'),
  size = 48
}: InputEventOffsetEUMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_434_167)'>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M11.8 13.2C5.83532 13.2 1 18.0353 1 24C1 29.9647 5.83532 34.8 11.8 34.8C17.7647 34.8 22.6 29.9647 22.6 24C22.5934 18.0381 17.762 13.2066 11.8 13.2Z' fill='${borderColor}'/>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M11.8 33C16.7705 33 20.8 28.9705 20.8 24C20.8 19.0294 16.7705 15 11.8 15C6.82944 15 2.8 19.0294 2.8 24C2.80557 28.9683 6.83175 32.9944 11.8 33Z' fill='${fillColor}'/>
        <path d='M11.8 33C16.7706 33 20.8 28.9706 20.8 24C20.8 19.0294 16.7706 15 11.8 15C6.82944 15 2.8 19.0294 2.8 24C2.8 28.9706 6.82944 33 11.8 33Z' fill='#C629DD'/>
        <path d='M9.09999 19.5C8.27966 19.9538 7.59796 20.609 7.12384 21.3992C6.64973 22.1894 6.39999 23.0866 6.39999 24C6.39999 24.9134 6.64973 25.8106 7.12384 26.6008C7.59796 27.391 8.27966 28.0461 9.09999 28.5' stroke='white' stroke-width='2' stroke-miterlimit='10' stroke-linecap='round'/>
        <path d='M14.5 19.5C15.3204 19.9538 16.002 20.609 16.4761 21.3992C16.9502 22.1894 17.2 23.0866 17.2 24C17.2 24.9134 16.9502 25.8106 16.4761 26.6008C16.002 27.391 15.3204 28.0461 14.5 28.5' stroke='white' stroke-width='2' stroke-miterlimit='10' stroke-linecap='round'/>
        <path d='M11.8 25.8C12.7941 25.8 13.6 24.9941 13.6 24C13.6 23.0059 12.7941 22.2 11.8 22.2C10.8059 22.2 10 23.0059 10 24C10 24.9941 10.8059 25.8 11.8 25.8Z' fill='${borderColor}' stroke='white'/>
      </g>
      <defs>
        <clipPath id='clip0_434_167'>
          <rect width='21.6' height='21.6' fill='${borderColor}' transform='translate(1 13.2)'/>
        </clipPath>
      </defs>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getInputEventOffsetEUMarker;
